/**
 * Live meeting transcript retention.
 *
 * Transcripts and recordings are auto-deleted from S3 by a 30-day lifecycle
 * rule (contractual retention limit; infrastructure/modules/s3bucket/main.tf).
 * The backend mirrors this window in get-transcript.js (RETENTION_DAYS); keep
 * all three in sync if the policy changes.
 * Kept in its own module so the age logic is unit-testable without pulling
 * in jsPDF/styled-components.
 */

export const TRANSCRIPT_RETENTION_DAYS = 30;

const RETENTION_MS = TRANSCRIPT_RETENTION_DAYS * 24 * 60 * 60 * 1000;

export const TRANSCRIPT_EXPIRED_MESSAGE =
  'This transcript is no longer available. Transcripts and recordings are ' +
  `automatically deleted ${TRANSCRIPT_RETENTION_DAYS} days after a meeting. ` +
  'Your meeting report is unaffected.';

/**
 * True when the meeting is past the retention window, meaning its transcript
 * has been (or is about to be) deleted from S3.
 *
 * @param {string|null|undefined} meetingDate ISO date (meeting.meetingDate)
 * @param {number} nowMs injectable clock for tests
 */
export function isTranscriptExpired(meetingDate, nowMs = Date.now()) {
  if (!meetingDate) return false;
  const meetingMs = Date.parse(meetingDate);
  if (!Number.isFinite(meetingMs)) return false;
  return nowMs - meetingMs > RETENTION_MS;
}
